import type { IXShareSummary } from "~/feature/chart/components/XShareDialog/types";

import { buildXPostText, withXMention } from "./buildXPostText";
import { getXPostLimit } from "./getXPostLimit";

interface IXShareFormParams {
  summary: IXShareSummary | null;
  hasLink: boolean;
  draft: string | null;
  mention: boolean;
  hashtagsEnabled: boolean;
  hashtags: string;
}

export const getXShareForm = ({
  summary,
  hasLink,
  draft,
  mention,
  hashtagsEnabled,
  hashtags,
}: IXShareFormParams) => {
  const text = draft ?? (summary ? buildXPostText(summary) : "");
  const activeHashtags = hashtagsEnabled ? hashtags : null;
  const limit = getXPostLimit({
    mention,
    link: hasLink,
    hashtags: activeHashtags,
  });

  return {
    text,
    postText: withXMention(text, mention),
    activeHashtags,
    length: text.length,
    limit,
    isOverLimit: text.length > limit,
  };
};
